export default __webpack_public_path__ + "static/media/tc.33777da9.svg";